module.exports = __webpack_public_path__ + "img/shop-code.a44571e9.png";